/**
 * @flow
 * @relayHash 6ea362c2ecff47f4f7078fc3e30d8a45
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DownloadCatalogInput = {|
  modalFormName?: ?string,
  modalDownload?: ?boolean,
  memberId?: ?string,
  emailAddress?: ?string,
  langCode?: ?string,
  inquiryName?: ?string,
  inquiryId?: ?string,
  title?: ?string,
  motive?: ?number,
  productService?: ?number,
  introductionTime?: ?number,
  positions?: ?$ReadOnlyArray<?number>,
  inquiryDetail?: ?string,
  lastName?: ?string,
  firstName?: ?string,
  phoneNumber?: ?string,
  companyName?: ?string,
  officeName?: ?string,
  departmentName?: ?string,
  businessType?: ?string,
  jobCategoryType?: ?string,
  subdivisionCode?: ?string,
  companyContractDisplayId?: ?number,
  catalogId?: ?number,
  companyId?: ?number,
  clientMutationId?: ?string,
|};
export type DownloadCatalogMutationVariables = {|
  input: DownloadCatalogInput
|};
export type DownloadCatalogMutationResponse = {|
  +downloadCatalog: ?{|
    +downloadedCatalog: ?{|
      +status: ?boolean,
      +catalogId: ?number,
      +catalogName: ?string,
      +catalogPath: ?string,
      +companyId: ?number,
      +companyName: ?string,
      +companyPath: ?string,
      +recommendCatalogs: ?$ReadOnlyArray<?{|
        +catalog: ?{|
          +cluezCatalogId: ?string,
          +cluezCompanyId: ?string,
          +cluezCategoryIdPath: ?string,
          +imageUrl1: ?string,
          +previewImageUrl1: ?string,
          +previewImageUrl2: ?string,
          +previewImageUrl3: ?string,
          +previewImageUrl4: ?string,
          +videoUrl: ?string,
          +documentGroupId: ?string,
          +documentDisplayId: ?string,
          +documentName: ?string,
          +documentOriginalName: ?string,
          +documentSubName: ?string,
          +documentUrl: ?string,
          +documentSizeBytes: ?number,
          +documentDescription: ?string,
          +documentPublishFlag: ?boolean,
          +documentConversionFlag: ?boolean,
          +documentExternalSiteFlag: ?boolean,
          +companyContractId: ?string,
          +companyContractDisplayId: ?number,
          +companyNameLangValue: ?string,
          +companyLogoUrlLangValue: ?string,
          +catalogId: ?string,
          +humanFileSize: ?string,
        |},
        +brand: ?{|
          +brandId: ?number,
          +urlId: ?number,
          +nameLangValue: ?string,
          +manufacturerBrandImageLangValue: ?string,
        |},
        +document: ?{|
          +documentId: ?string,
          +documentType: ?string,
          +documentUrl: ?string,
          +documentDisplayId: ?string,
          +documentSubName: ?string,
          +documentPublishFlag: ?boolean,
          +documentConversionFlag: ?string,
          +documentDescription: ?string,
          +documentExternalSiteFlag: ?string,
          +documentGroupId: ?string,
          +documentName: ?string,
          +documentOriginalName: ?string,
          +documentSizeBytes: ?number,
          +displayDocumentOriginalName: ?string,
          +langKey: ?string,
          +firstDocumentImageUrl: ?string,
          +humanFileSize: ?string,
        |},
        +label: ?string,
        +langKey: ?string,
        +humanFileSize: ?string,
        +firstDocumentImageUrl: ?string,
        +displayDocumentOriginalName: ?string,
        +_score: ?string,
      |}>,
    |}
  |}
|};
export type DownloadCatalogMutation = {|
  variables: DownloadCatalogMutationVariables,
  response: DownloadCatalogMutationResponse,
|};
*/


/*
mutation DownloadCatalogMutation(
  $input: DownloadCatalogInput!
) {
  downloadCatalog(input: $input) {
    downloadedCatalog {
      status
      catalogId
      catalogName
      catalogPath
      companyId
      companyName
      companyPath
      recommendCatalogs {
        catalog {
          cluezCatalogId
          cluezCompanyId
          cluezCategoryIdPath
          imageUrl1
          previewImageUrl1
          previewImageUrl2
          previewImageUrl3
          previewImageUrl4
          videoUrl
          documentGroupId
          documentDisplayId
          documentName
          documentOriginalName
          documentSubName
          documentUrl
          documentSizeBytes
          documentDescription
          documentPublishFlag
          documentConversionFlag
          documentExternalSiteFlag
          companyContractId
          companyContractDisplayId
          companyNameLangValue
          companyLogoUrlLangValue
          catalogId
          humanFileSize
        }
        brand {
          brandId
          urlId
          nameLangValue
          manufacturerBrandImageLangValue
        }
        document {
          documentId
          documentType
          documentUrl
          documentDisplayId
          documentSubName
          documentPublishFlag
          documentConversionFlag
          documentDescription
          documentExternalSiteFlag
          documentGroupId
          documentName
          documentOriginalName
          documentSizeBytes
          displayDocumentOriginalName
          langKey
          firstDocumentImageUrl
          humanFileSize
        }
        label
        langKey
        humanFileSize
        firstDocumentImageUrl
        displayDocumentOriginalName
        _score
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DownloadCatalogInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "catalogId",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "documentGroupId",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "documentDisplayId",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "documentName",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "documentOriginalName",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "documentSubName",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "documentUrl",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "documentSizeBytes",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "documentDescription",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "documentPublishFlag",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "documentConversionFlag",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "documentExternalSiteFlag",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "humanFileSize",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayDocumentOriginalName",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "langKey",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstDocumentImageUrl",
  "args": null,
  "storageKey": null
},
v17 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "downloadCatalog",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DownloadCatalogPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "downloadedCatalog",
        "storageKey": null,
        "args": null,
        "concreteType": "DownloadedCatalog",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "catalogName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "catalogPath",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "companyId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "companyName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "companyPath",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "recommendCatalogs",
            "storageKey": null,
            "args": null,
            "concreteType": "SearchCatalog",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "catalog",
                "storageKey": null,
                "args": null,
                "concreteType": "Catalog",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cluezCatalogId",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cluezCompanyId",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cluezCategoryIdPath",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "imageUrl1",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "previewImageUrl1",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "previewImageUrl2",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "previewImageUrl3",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "previewImageUrl4",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "videoUrl",
                    "args": null,
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "companyContractId",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "companyContractDisplayId",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "companyNameLangValue",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "companyLogoUrlLangValue",
                    "args": null,
                    "storageKey": null
                  },
                  (v1/*: any*/),
                  (v13/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "brand",
                "storageKey": null,
                "args": null,
                "concreteType": "ManufacturerBrand",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "brandId",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "urlId",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "nameLangValue",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "manufacturerBrandImageLangValue",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "document",
                "storageKey": null,
                "args": null,
                "concreteType": "Document",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "documentId",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "documentType",
                    "args": null,
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v3/*: any*/),
                  (v6/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v9/*: any*/),
                  (v12/*: any*/),
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v8/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v13/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "label",
                "args": null,
                "storageKey": null
              },
              (v15/*: any*/),
              (v13/*: any*/),
              (v16/*: any*/),
              (v14/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "_score",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DownloadCatalogMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v17/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DownloadCatalogMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v17/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DownloadCatalogMutation",
    "id": null,
    "text": "mutation DownloadCatalogMutation(\n  $input: DownloadCatalogInput!\n) {\n  downloadCatalog(input: $input) {\n    downloadedCatalog {\n      status\n      catalogId\n      catalogName\n      catalogPath\n      companyId\n      companyName\n      companyPath\n      recommendCatalogs {\n        catalog {\n          cluezCatalogId\n          cluezCompanyId\n          cluezCategoryIdPath\n          imageUrl1\n          previewImageUrl1\n          previewImageUrl2\n          previewImageUrl3\n          previewImageUrl4\n          videoUrl\n          documentGroupId\n          documentDisplayId\n          documentName\n          documentOriginalName\n          documentSubName\n          documentUrl\n          documentSizeBytes\n          documentDescription\n          documentPublishFlag\n          documentConversionFlag\n          documentExternalSiteFlag\n          companyContractId\n          companyContractDisplayId\n          companyNameLangValue\n          companyLogoUrlLangValue\n          catalogId\n          humanFileSize\n        }\n        brand {\n          brandId\n          urlId\n          nameLangValue\n          manufacturerBrandImageLangValue\n        }\n        document {\n          documentId\n          documentType\n          documentUrl\n          documentDisplayId\n          documentSubName\n          documentPublishFlag\n          documentConversionFlag\n          documentDescription\n          documentExternalSiteFlag\n          documentGroupId\n          documentName\n          documentOriginalName\n          documentSizeBytes\n          displayDocumentOriginalName\n          langKey\n          firstDocumentImageUrl\n          humanFileSize\n        }\n        label\n        langKey\n        humanFileSize\n        firstDocumentImageUrl\n        displayDocumentOriginalName\n        _score\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '666b4339c0161c570edfd690b4376446';
module.exports = node;
